// クレカ申請 審査申請回答登録画面のラベル
export const LABELS = {
  APPLICATION_FILE: "申請結果ファイル",
  ORDER_TARGET_NAME: "仕向け先",
  ANSWER_STATUS_TITLE: "審査申請・回答状況検索",
  ANSWER_STATUS_LABEL: "審査申請・回答状況一覧",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  RESPONSE_DATE: "審査結果回答日",
  APPLICATION_PERIOD: "申請期間",
  FILING_DATE: "申請日",
  APPLICATION_RESULT_RESPONSE_DATE: "申込結果回答日",
  APPLICATION_FILE_NAME: "申込審査情報ファイル名",
  RESULT_FILE_NAME: "審査結果ファイル名",
  APPLICATION_RESULT_FILE_NAME: "申込結果ファイル名",
  APPLICATION_STATUS: "申請状況",
  APPLICATION_STATUS_APPLYING: "申請中",
  APPLICATION_STATUS_COMPLETE: "回答済み",
  APPLICATION_STATUS_PART_COMPLETE: "回答済み（一部）",
  APPLICATION_STATUS_DOWNLOAD_WAIT: "ダウンロード待ち",
  EMPTY: "　",
  FROM: "～",
  NO: "No",
  REFERENCE: "　　参照　　",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION_EXCEL: ".xlsx",
  FILE_EXTENSION_CSV: ".csv",
  FILE_EXTENSION_EXCEL_CSV: ".xlsx,.csv",
  UPLOAD_TYPE: "uploadType",
  ORDER_TARGET_CODE: "orderTargetCode",
  ORDER_TARGET_NAME: "orderTargetName",
  APPLICATION_RESPONSE_DATE: "applicationResponseDate",
  SUCCESS: "success",
  PERIOD: "。",
  SELECT_ITEM: "selectItem",
  QUERY_PARAMETER_ORDER_TARGET_CODE: "orderTargetCode",
} as const;

export const CONTENTS = {
  APPLICATION_CONFIRM: "\r\n・仕向け先:{0}\r\n　　ファイル名：{1}",
} as const;

// SELECTの空行の定義
export const SELECT_BLANK = { label: "　", value: "" };

// 交渉状況
export const STATUS_LIST = [
  SELECT_BLANK,
  { label: LABELS.APPLICATION_STATUS_APPLYING, value: "1" },
  { label: LABELS.APPLICATION_STATUS_PART_COMPLETE, value: "2" },
  { label: LABELS.APPLICATION_STATUS_COMPLETE, value: "3" },
  { label: LABELS.APPLICATION_STATUS_DOWNLOAD_WAIT, value: "4" },
];

export const ORDER_TARGET_LIST = [
  { label: "omni（変更審査）", value: "11" },
  { label: "omni（途上審査）", value: "12" },
  { label: "クレカ依頼（SMCC）", value: "3" },
  { label: "クレカ依頼（TF）", value: "4" },
  { label: "クレカ依頼（セゾン）", value: "5" },
  { label: "クレカ依頼（JCB）", value: "2" },
  { label: "クレカ依頼（AMEX）", value: "1" },
  { label: "POS登録（TF）", value: "8" },
  { label: "POS登録（JCB）", value: "7" },
  { label: "POS登録（AMEX）", value: "6" },
  { label: "GMOPG", value: "9" },
  { label: "NTT-F", value: "10" },
];

export const ORDER_TARGET_LIST_SEARCH = [
  { label: "クレカ依頼（SMCC）", value: "3" },
  { label: "クレカ依頼（TF）", value: "4" },
  { label: "クレカ依頼（セゾン）", value: "5" },
  { label: "クレカ依頼（JCB）", value: "2" },
  { label: "クレカ依頼（AMEX）", value: "1" },
  { label: "POS登録（TF）", value: "8" },
  { label: "POS登録（JCB）", value: "7" },
  { label: "POS登録（AMEX）", value: "6" },
  { label: "GMOPG", value: "9" },
  { label: "NTT-F", value: "10" },
  { label: "クレカ依頼（omni）", value: "11" },
];

export const ORDER_TARGET_CODE_OMNI = {
  OMNI_VM: 8,
  OMNI_JCB: 9,
  OMNI_AMEX: 10,
};
